// extracted by mini-css-extract-plugin
module.exports = {"primary":"#959595","secondary":"#00bcd4","goscontainer":"AppFAB_goscontainer_3zzxs"};